import React from 'react';

import Row from 'components/Row';
import MediaObject from 'components/MediaObject';
import List from 'components/List';
import ListItem from 'components/ListItem';
import TextWithIcon from 'components/TextWithIcon';
import Link from 'components/Link';
import Button from 'components/ButtonDeprecated';
import CoachingScheduleInstanceDescription from './CoachingScheduleInstanceDescription';
import { InstanceTextBadge } from 'coaching/components/CoachingHomeView/CoachingSessionInstanceRowComponents';
import {
  GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach
} from 'coaching/queries/__generated__/GetCoachDashboardScheduleInstances';


export type InstanceRowComponentProps = GetCoachDashboardScheduleInstances_coaching_coachingSessionInstancesForCoach & {
  onClickMessage?: () => void;
};

export default function CoachingScheduleSessionRowStacked(props: InstanceRowComponentProps) {
  const {
    startDateTime,
    endDateTime,
    participant,
    sessionSchedule,
    cancelled,
    cancelledLate,
    added
  } = props;

  return (
    <Row size="xsmall">
      <List data-test="coaching-schedule-stacked-list" size="medium">
        <ListItem data-test="coaching-schedule-stacked-item">
          <CoachingScheduleInstanceDescription
            startDateTime={startDateTime}
            endDateTime={endDateTime}
            participantName={participant?.studentName}
            subjectName={sessionSchedule?.subject?.name}
            studentGradeLevel={participant?.studentGradeLevel}
            isCancelled={cancelled}
          />
        </ListItem>
        <ListItem data-test="coaching-schedule-stacked-item">
          <InstanceTextBadge
            textBadgeTextColorCancellation="apple"
            colorBadgeCancellation="apple-lightest"
            isLateCancelled={cancelledLate}
            isCancelled={cancelled}
            isPartOfRecurringSchedule={!added}
            userHasNoRecurringSchedules={!added}
          />
        </ListItem>
        <ListItem data-test="coaching-schedule-stacked-item">
          <Link
            color="chalkboard"
            data-test="coaching-schedule-session-stream"
            to={`/coaching/messages/${participant?.sessionTools?.stream?.uuid}`}
            weight="semibold">
            <Button size="xxsmall" level="secondary" color="chalkboard">
              <TextWithIcon icon="message" iconSize="medium" size="small">
                Message
              </TextWithIcon>
            </Button>
          </Link>
        </ListItem>
      </List>
    </Row>
  );
}
